import { Button } from '@/components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import type { ReactNode } from 'react'
import { Form } from '@/components/Form'
import illustrationUrl from '@/assets/misc/img_team.svg'

export interface InviteTeamMemberModalProps {
  showing: boolean
  onClose: () => unknown
  corporateMode: boolean
  onSend: () => unknown
  isSendPending: boolean
  inviteCount: number
  children: ReactNode
}

function formatButtonText(count: number) {
  return count === 0
    ? 'Send'
    : count === 1
      ? 'Send Invite'
      : `Send ${count} Invites`
}

export function InviteTeamMemberModal({
  showing,
  onClose,
  corporateMode,
  onSend,
  isSendPending,
  inviteCount,
  children,
}: InviteTeamMemberModalProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSendPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={illustrationUrl}
              alt="Illustration of a group"
            />
          )}
          <ModalSheetContentTitle>
            Invite people to your team
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Lets get the ball rolling.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <Form onSubmit={onSend}>{children}</Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Cancel" onPress={onClose} isDisabled={isSendPending} />
          <Button
            label={formatButtonText(inviteCount)}
            variant="primary"
            onPress={onSend}
            isPending={isSendPending}
            isDisabled={isSendPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
